import firebase from './firebase';

const db = firebase.firestore();

export default db;


// WEBPACK FOOTER //
// ./src/db.js